const initialState = {
  // Is Printing Invoice Ledger Report
  isPrintingInvoiceLedgerReport: false,
};

const LedgerReportsReducer = (state = initialState, action) => {
  switch (action.type) {
    // Getting Admin Dashboard Credentials
    case "PRINT_INVOICE_LEDGER_REPORT_REQUEST":
      return {
        ...state,
        isPrintingInvoiceLedgerReport: true,
      };
    case "PRINT_INVOICE_LEDGER_REPORT_SUCCESS":
      return {
        ...state,
        isPrintingInvoiceLedgerReport: false,
      };
    case "PRINT_INVOICE_LEDGER_REPORT_ERROR":
      return {
        ...state,
        isPrintingInvoiceLedgerReport: false,
      };
    default:
      return state;
  }
};

export default LedgerReportsReducer;
